export const MAX_STEPS = 10;

export const STEP_TYPES = {
  VISIT: 'VISIT',
  GOAL: 'GOAL',
};

export const FUNNELS_ORDER = {
  CREATED_AT: 'CREATED_AT',
  NAME: 'NAME',
};

export const ENTER_SITE = 'Enter site';

export const METRICS = {
  VISITORS: 'Visitors',
  CONVERSIONS: 'Conversions',
  CONVERSION_RATE: 'Conversion Rate',
  AVG_VALUE: 'Average Value (_CURRENCY_)',
  TOTAL_VALUE: 'Total Value (_CURRENCY_)',
};
